import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-soctrip-dropdown-list',
  templateUrl: './soctrip-dropdown-list.component.html',
  styleUrls: ['./soctrip-dropdown-list.component.scss']
})
export class SoctripDropdownListComponent {

  @Input() listItems: any[] = []; //object with 2 property label, value 
  @Input() selectedItems: any[] = [];
  @Input() allowTickAll: boolean = false;
  @Input() tickAllIsDefault: boolean = false;
  @Input() notFoundLabel: string;
  @Input() allItemLabel: string;
  @Input() placehoder: string;
  @Input() searchKey: string;
  @Input() allowSearch: boolean = false;
  @Input() placehoderSearch: string;
  @Input() showAllItemPlaceHoder: boolean = true;
  @Input() notFoundIcon: string = 'sctr-icon-building-07';
  @Output() exportItems = new EventEmitter();

  filteredItems: any[] = [];
  isShowListItems: boolean = false;
  isSelectedAllItem: boolean = false;
  // searchKey = '';

  isInitData: boolean = true;

  //debound search item
  search$ = new Subject<any>();

  constructor(){}

  ngOnInit(): void {
    this.filteredItems = this.listItems;
    if (this.tickAllIsDefault && this.selectedItems.length == 0) {
      this.selectedItems = [...this.listItems];
      this.isSelectedAllItem = true;
    }
    this.search$.pipe(debounceTime(300)).subscribe(() => {
      this.handleSearch(this.searchKey.trim());
    });
    this.selectItem();
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (changes['listItems'] && this.listItems.length > 0 && this.isInitData) {
      if (this.tickAllIsDefault && this.selectedItems.length == 0) {
        this.selectedItems = [...this.listItems];
        this.isSelectedAllItem = true;
      }
      this.isInitData = false;
    } else if (changes['listItems'] && !this.isInitData) {
      // this.selectItem$.next(this.selectedItems)
    }
    this.selectItem();
  }

  onClosePopup() {
    this.exportItems.emit(this.selectedItems);
  }

  onSearchInputChange() {
    this.search$.next(this.searchKey);
  }

  clearSearchKey() {
    this.searchKey = '';
    this.search$.next(this.searchKey);
  }

  toggleListItems(): void {
    this.isShowListItems = !this.isShowListItems;
    this.exportItems.emit(this.selectedItems);
  }
  
  changeSelectedAllItems() {
    if (!this.isSelectedAllItem) {
      this.selectedItems = [...this.listItems];
      this.isSelectedAllItem = true;
    } else {
      this.selectedItems = [];
      this.isSelectedAllItem = false;
    }
  }

  selectItem(): void {
    this.isSelectedAllItem = this.selectedItems.length == this.listItems.length;
  }

  handleSearch(key: string) {
     const searchTerm = key.toLowerCase() || '';
    if (!searchTerm) {
      this.filteredItems = [...this.listItems];
      return;
    }
    this.filteredItems = this.listItems.filter(item => {
      const searchNormalized = this.removeVietnameseTones(item.value.toLowerCase());
      const termNormalized = this.removeVietnameseTones(searchTerm);
      return searchNormalized.includes(termNormalized);
    });
  }

  // Hàm loại bỏ dấu tiếng Việt
  removeVietnameseTones(str: string) {
    return str.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  }
}

interface Item {
  label: string,
  value: string
}
